document.addEventListener("DOMContentLoaded", function() {
   
    function updateImageForSwatch(input) {
        const selectedColor = input.value;
        const productInfoWrapper = input.closest('.m-product-info--wrapper');
        const productUrlInput = productInfoWrapper.querySelector('.collection-variant');
        const productUrl = productUrlInput.dataset.productUrl.split('?')[0];
        fetch(productUrl + ".js")
        .then(response => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        })
        .then(productJson => {
            const colorVariant = productJson.variants.find(e => e.title.includes(selectedColor));
            const imgSrc = colorVariant.featured_media.preview_image.src;
            const mainImage = input.closest('.m-product-card').querySelector('.m-product-card__main-image img');
            mainImage.src = `${imgSrc}&width=533`;
            mainImage.removeAttribute("srcset");
            mainImage.alt = selectedColor;
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
        });
    }

   
    function showImagesForCheckedInputs() {
        const checkedInputs = document.querySelectorAll('input[name="Color"]:checked');
        checkedInputs.forEach(function(input) {
            updateImageForSwatch(input);
        });
    }

    
    showImagesForCheckedInputs();
});
